import { FC } from "react";
import { Form, Rate } from "antd";
import { BaseFilter } from "src/constants";

const RateGroup: FC<{
  filter: BaseFilter;
  valuesMap?: Map<any, any[]>;
}> = ({
  filter,
}) => {
  return (
    <Form.Item name={filter.key} className="m-0!">
      <Rate style={{ color: "var(--color-icon-rating-star)" }} />
    </Form.Item>
  );
};

export default RateGroup;